import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText, Spinner } from 'triider-components';
import { validateUserFields } from 'utils/userValidation';
import iconEmail from 'assets/img/email-icon.svg';
import { Creators as UiCreators } from 'store/ducks/ui';
import { Creators as AuthCreators } from 'store/ducks/auth';


import {
  Container, BoxRecovery, Icon, Title, Desc, StyledButtonTriider,
} from './styles';

class CreateNewPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      token: '',
      errors: {},
      password: '',
    };

    this.setFields = this.setFields.bind(this);
    this.validateField = this.validateField.bind(this);
    this.send = this.send.bind(this);
  }

  componentDidMount() {
    const { match, _forgotPasswordCheckToken } = this.props;
    const { email, token } = match.params;

    _forgotPasswordCheckToken({ email, token });

    this.setState({ email, token });
  }

  setFields({ target }) {
    const { name, value } = target;

    this.setState({ [name]: value });
  }

  validateField({ target }) {
    const { name, value } = target;

    const message = validateUserFields(name, value);

    const { errors: oldErrors } = this.state;

    const errors = {
      ...oldErrors,
      [name]: message,
    };

    this.setState({ errors });
  }

  send(e) {
    e.preventDefault();

    const { email, token, password } = this.state;

    const errors = {
      password: validateUserFields('password', password),
    };

    if (!Object.values(errors).some(e => !!e)) {
      const { _forgotPasswordUpdatePassword } = this.props;
      _forgotPasswordUpdatePassword({ email, token, password });
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { password, errors } = this.state;
    const { isLoading, isTokenValid } = this.props;

    const buttonDisabled = !password || Object.values(errors).some(e => !!e);
    return (
      isLoading ? (
        <Spinner size="larger" />
      ) : (
        <Container>
          <BoxRecovery>
            { isTokenValid ? <Icon isTokenValid /> : <Icon /> }
            <Title>{ isTokenValid ? 'Crie uma nova senha' : 'Este link expirou' }</Title>
            {!isTokenValid && (
              <Desc>
                Peça de novo a troca da senha para acessar um link válido. Expiramos os links de
                "esqueci minha senha" para proteger os nossos usuários.
              </Desc>
            )}
            <form onSubmit={this.send}>
              {isTokenValid && (
                <InputText
                  placeholder="Crie uma nova senha:"
                  type="password"
                  name="password"
                  value={password}
                  error={errors.password}
                  scrollView={false}
                  onChange={this.setFields}
                  onBlur={this.validateField}
                  isPasswordRegister
                />
              )}

              {
                isTokenValid ? (
                  <StyledButtonTriider
                    type="submit"
                    size="fullBlock"
                    disabled={buttonDisabled}
                    isLoading={isLoading}
                  >
                    Enviar
                  </StyledButtonTriider>
                ) : (
                  <StyledButtonTriider isLoading={isLoading} type="button" size="fullBlock">
                    Esqueci minha senha
                  </StyledButtonTriider>
                )
              }
            </form>
          </BoxRecovery>
        </Container>
      )
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.ui.loaders.includes('RECOVERY_PASSWORD'),
  isTokenValid: state.auth.isTokenValid,
});

const mapDispatchToProps = {
  _forgotPasswordCheckToken: AuthCreators.forgotPasswordCheckTokenRequest,
  _forgotPasswordUpdatePassword: AuthCreators.forgotPasswordUpdatePasswordRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateNewPassword);
